import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function SvgComponent({stroke = '#FFF', ...props}) {
  return (
    <Svg
      width={15}
      height={15}
      viewBox="0 0 15 15"
      fill="none"
    >
      <G
        clipPath="url(#clip0_2734_2729)"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <Path d="M7.5.682v13.636M.682 6.818h13.636" />
      </G>
      <Defs>
        <ClipPath id="clip0_2734_2729">
          <Path stroke={stroke} d="M0 0H15V15H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default SvgComponent
